module.exports = __webpack_public_path__ + "img/7.7d738d9f.jpg";